import React from 'react';
import { FacebookIcon, InstagramIcon, PhoneIcon, MailIcon, MapPinIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0B1F3A] text-white" data-id="element-75">
      <div className="max-w-7xl mx-auto px-4 py-12" data-id="element-76">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-8" data-id="element-77">
          {/* Logo & Description */}
          <div data-id="element-78">
            <h3 className="text-2xl font-bold mb-4" data-id="element-79">Judah Medical Transport</h3>
            <p className="text-gray-300 mb-4" data-id="element-80">
              Dependable Medical Transportation in Upper Marlboro, MD
            </p>
            <div className="flex space-x-4 mb-4" data-id="element-81">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white bg-opacity-10 rounded-full flex items-center justify-center hover:bg-[#E63946] transition-colors" aria-label="Facebook" data-id="element-82">
                <FacebookIcon className="h-5 w-5" data-id="element-83" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white bg-opacity-10 rounded-full flex items-center justify-center hover:bg-[#E63946] transition-colors" aria-label="Instagram" data-id="element-84">
                <InstagramIcon className="h-5 w-5" data-id="element-85" />
              </a>
            </div>
            <div className="bg-[#E63946] rounded-lg px-4 py-2 inline-block" data-id="element-86">
              <p className="font-bold text-sm" data-id="element-87">Licensed & Insured</p>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-88">
            <h4 className="text-lg font-bold mb-4" data-id="element-89">Quick Links</h4>
            <ul className="space-y-2" data-id="element-90">
              <li data-id="element-91">
                <a href="/" className="text-gray-300 hover:text-[#E63946] transition-colors" data-id="element-92">
                  Home
                </a>
              </li>
              <li data-id="element-93">
                <a href="/about" className="text-gray-300 hover:text-[#E63946] transition-colors" data-id="element-94">
                  About Us
                </a>
              </li>
              <li data-id="element-95">
                <a href="/services" className="text-gray-300 hover:text-[#E63946] transition-colors" data-id="element-96">
                  Services
                </a>
              </li>
              <li data-id="element-97">
                <a href="/service-areas" className="text-gray-300 hover:text-[#E63946] transition-colors" data-id="element-98">
                  Service Areas
                </a>
              </li>
              <li data-id="element-99">
                <a href="/blog" className="text-gray-300 hover:text-[#E63946] transition-colors" data-id="element-100">
                  Blog
                </a>
              </li>
              <li data-id="element-101">
                <a href="/contact" className="text-gray-300 hover:text-[#E63946] transition-colors" data-id="element-102">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-103">
            <h4 className="text-lg font-bold mb-4" data-id="element-104">Contact</h4>
            <ul className="space-y-3" data-id="element-105">
              <li className="flex items-start space-x-3" data-id="element-106">
                <PhoneIcon className="h-5 w-5 text-[#E63946] flex-shrink-0 mt-1" data-id="element-107" />
                <div className="flex flex-col" data-id="element-108">
                  <a href="tel:2405653357" className="text-gray-300 hover:text-[#E63946] transition-colors" data-id="element-109">
                    240-565-3357
                  </a>
                  <a href="tel:3014300712" className="text-gray-300 hover:text-[#E63946] transition-colors" data-id="element-110">
                    301-430-0712
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3" data-id="element-111">
                <MailIcon className="h-5 w-5 text-[#E63946] flex-shrink-0 mt-1" data-id="element-112" />
                <a href="mailto:judahnursingservices@gmail.com" className="text-gray-300 hover:text-[#E63946] transition-colors break-all" data-id="element-113">
                  judahnursingservices@gmail.com
                </a>
              </li>
              <li className="flex items-start space-x-3" data-id="element-114">
                <MapPinIcon className="h-5 w-5 text-[#E63946] flex-shrink-0 mt-1" data-id="element-115" />
                <span className="text-gray-300" data-id="element-116">Upper Marlboro, MD</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8" data-id="element-117">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0" data-id="element-118">
            <p className="text-gray-400 text-sm" data-id="element-119">
              © 2024 Judah Medical Transport Company. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm" data-id="element-120">
              <a href="#terms" className="text-gray-400 hover:text-[#E63946] transition-colors" data-id="element-121">
                Terms of Service
              </a>
              <a href="#hipaa" className="text-gray-400 hover:text-[#E63946] transition-colors" data-id="element-122">
                HIPAA Notice
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}